<template>
    <div class="layout-popup detail-share-pop">
        <div class="discuss-share-note detail-share-note">
            <p>请先点击右上角保存后<br />再进行批盘论盘操作</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DetailSharePop'
}
</script>